export const foreignRegions = [
    {
        "label": "CORP",
        "value": "CORP"
    },
    {
        "label": "LATAM",
        "value": "LATAM"
    },
    {
        "label": "SINGAP",
        "value": "SINGAP"
    },
    {
        "label": "ASIA",
        "value": "ASIA"
    },
    {
        "label": "ARV",
        "value": "ARV"
    },
    {
        "label": "CRM",
        "value": "CRM"
    },
    {
        "label": "NEPAL",
        "value": "NEPAL"
    },
    {
        "label": "AFRICA",
        "value": "AFRICA"
    },
    {
        "label": "CIS",
        "value": "CIS"
    },
    {
        "label": "MENA",
        "value": "MENA"
    },
    {
        "label": "EMCUCV",
        "value": "EMCUCV"
    },
    {
        "label": "MEAGCC",
        "value": "MEAGCC"
    },
    {
        "label": "MEAOTH",
        "value": "MEAOTH"
    },
    {
        "label": "REG",
        "value": "REG"
    },
    {
        "label": "IMPETU",
        "value": "IMPETU"
    },
    {
        "label": "MKTG",
        "value": "MKTG"
    },
    {
        "label": "ENG",
        "value": "ENG"
    },
    {
        "label": "BDEV",
        "value": "BDEV"
    },
    {
        "label": "IT",
        "value": "IT"
    },
    {
        "label": "MRNA",
        "value": "MRNA"
    },
    {
        "label": "MUSP",
        "value": "MUSP"
    },
    {
        "label": "STOR",
        "value": "STOR"
    },
    {
        "label": "Corp",
        "value": "Corp"
    },
    {
        "label": "ADL",
        "value": "ADL"
    },
    {
        "label": "CLINR",
        "value": "CLINR"
    },
    {
        "label": "DSP",
        "value": "DSP"
    },
    {
        "label": "IMMU",
        "value": "IMMU"
    },
    {
        "label": "QUCM",
        "value": "QUCM"
    },
    {
        "label": "PUR",
        "value": "PUR"
    },
    {
        "label": "DIALY",
        "value": "DIALY"
    },
    {
        "label": "IPR",
        "value": "IPR"
    },
    {
        "label": "LEGL",
        "value": "LEGL"
    },
    {
        "label": "NA",
        "value": "NA"
    },
]

export const foreignRequiredFields = [
    { key: "region", label: "Region is mandarory or select Na" },
    { key: "invoiceDate", label: "Invoice Date" },
    { key: "invoiceNo", label: "Invoice Number" },
    { key: "grandTotal", label: "Grand Total" },
    { key: "headerText", label: "Header Text" },
    { key: "companyCode", label: "Company Code" },
    { key: "vendorCode", label: "Vendor Code" },
    { key: "vendorName", label: "Vendor Name" },
];
